module.exports = __webpack_public_path__ + "img/csr6.dac34e1a.jpg";